import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Fab } from '../../components';
import {
  currentGalleryCarIdSet,
  getAllGalleryImagesLow,
  getCurrentGalleryCarId,
  getGalleryZoomStep,
} from '../../store/gallery-slice';

import {
  carStatusSet,
  getActiveTab,
  getIsZoomEnabled,
} from '../../store/car-slice';
import { useDispatch, useSelector } from 'react-redux';

import FabControlled from '../../components/fab/fab-controlled';
import constants from '../../config/constants';
import { activeTabSet, getPrevTab } from '../../store/car-slice';

export default function GalleryButtons() {
  const isZoomEnabled = useSelector(getIsZoomEnabled);
  const prevTab = useSelector(getPrevTab);
  const activeTab = useSelector(getActiveTab);

  const zoomStep = useSelector(getGalleryZoomStep);
  const theme: any = useTheme();

  const isPortrait = useMediaQuery('(orientation: portrait)');

  const dispatch = useDispatch();
  const currentGalleryCarId = useSelector(getCurrentGalleryCarId);
  const { palette }: any = useTheme();

  const { interiorGalleryLow, exteriorGalleryLow } = useSelector(
    getAllGalleryImagesLow,
  );

  const handleClose = () => {
    if (activeTab === 'gallery' && prevTab === null) {
      dispatch(carStatusSet('VDP'));
    }
    dispatch(activeTabSet(prevTab));
  };

  const allGallery = React.useMemo(
    () => [...exteriorGalleryLow, ...interiorGalleryLow],
    [interiorGalleryLow, exteriorGalleryLow],
  );

  const handleClickNext = () => {
    const currentCarIndex = allGallery?.findIndex(
      (car: any) => car.id === currentGalleryCarId,
    );

    dispatch(
      currentCarIndex < allGallery?.length - 1
        ? currentGalleryCarIdSet(allGallery[currentCarIndex + 1]?.id)
        : currentGalleryCarIdSet(allGallery[0]?.id),
    );
  };

  const handleClickBack = () => {
    const currentCarIndex = allGallery?.findIndex(
      (car: any) => car.id === currentGalleryCarId,
    );

    dispatch(
      currentCarIndex === 0
        ? currentGalleryCarIdSet(allGallery[allGallery?.length - 1]?.id)
        : currentGalleryCarIdSet(allGallery[currentCarIndex - 1]?.id),
    );
  };

  const getItemSelectedIndex = React.useMemo(
    () => allGallery?.findIndex((item: any) => item.id === currentGalleryCarId),
    [allGallery],
  );

  return (
    <>
      {isZoomEnabled ? null : (
        <>
          <Fab
            background={palette.primary.contrastText}
            icon={
              <ArrowBackIosNewRoundedIcon
                sx={{
                  color: 'white',
                  fontSize: theme.spacing(4),
                }}
              />
            }
            onClick={handleClickBack}
            style={{
              margin: '1rem',
              left: 0,
              position: 'absolute',
            }}
          />
          <Fab
            background={palette.primary.contrastText}
            icon={
              <ArrowForwardIosRoundedIcon
                sx={{
                  color: 'white',
                  fontSize: theme.spacing(4),
                }}
              />
            }
            onClick={handleClickNext}
            style={{
              position: 'absolute',
              right: 0,
              margin: '1rem',
            }}
          />
        </>
      )}

      {zoomStep === 1 && (
        <Box
          sx={{
            position: 'absolute',
            right: '2rem',
            [theme.breakpoints.down('lg')]: {
              right: isPortrait ? '1rem' : '1.5rem',
            },
            top: '1rem',
            zIndex: 99999,
          }}
        >
          <FabControlled Icon={CloseRoundedIcon} onClick={handleClose} />
        </Box>
      )}

      {isZoomEnabled ? null : (
        <Box
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            top: '1rem',
            zIndex: 1,
            padding: '3px 15px',
            background: 'rgba( 0, 0, 0, 0.3 )',
            backdropFilter: constants.BLUR_STYLE.filter,
            borderRadius: '8px',
            border: '1px solid rgba( 255, 255, 255, 0.18 )',
          }}
        >
          <Typography
            color={'white'}
            sx={{
              fontWeight: '700',
              [theme.breakpoints.down('lg')]: {
                fontSize: '0.7rem',
              },
            }}
            textTransform={'capitalize'}
            variant="h6"
          >
            {getItemSelectedIndex + 1} / {allGallery?.length}
          </Typography>
        </Box>
      )}
    </>
  );
}
